/* complete_all_type.control_adapter.js */

var $ = require("jquery");
var _ = require("lodash");
var underscoreString = require("underscore.string");
_.mixin(underscoreString.exports());
var EventEmitter = require("events").EventEmitter;
var util = require("util");
var q = require("q");
const InputTextControlComponent = require("@gluenetworks/steve_ui_core").Control.Textfield
    .InputText;
const StyleUtil = require("../StyleUtil");

/**
 * @event CompleteAllTypeControlAdapter#ValueChanged
 * @type {Object}
 * @property oldValue {string} The previous value
 * @property newValue {string} The new value
 */

/**
 * @class CompleteAllTypeControlAdapter
 * @classdesc renders the Select Options Jtype.
 * @implements AngularControlAdapter
 *
 * @param logger {Bunyan} The logger
 * @param containingElem {DomElement} The containing dom element for this control
 * @param formCtrlDef {FormControlDefinition} The definition of this control object.
 *
 * @requires util
 * @requires EventEmitter
 *
 * @fires CompleteAllTypeControlAdapter#ValueChanged
 */
module.exports = function CompleteAllTypeAdapter(logger, containingElem, formCtrlDef, options) {
    var self = this;
    var loadedDeferred = q.defer();
    var addedItemPromises = [];
    //call Event Emitter Constructor
    this._multiEditMode = _.get(formCtrlDef, "displayModeOptions.multiEditMode", false);
    this._accordionDisplay = false;
    if (_.isArray(formCtrlDef.configSettings.allType)) {
        this._accordionDisplay = _.get(formCtrlDef, "configSettings.Display.accordion", false);
    } else if (_.isString(formCtrlDef.configSettings.allType)) {
        this._accordionDisplay = _.get(formCtrlDef, "configSettings.Display.accordion", false);
    } else {
        this._accordionDisplay = _.get(
            formCtrlDef,
            "configSettings.allType.@Display.accordion",
            false
        );
    }

    EventEmitter.call(this);
    var _scope;
    var _oldValue;
    let _oldInvalidStatus;
    let _oldInProgressStatus;
    var _typeConfigSettings;
    var _itemsRegistry = {};
    var uniquePropNameIndex = 1;

    /********************************************************************************/
    /*** START Type Definitions                                                   ***/
    /********************************************************************************/

    /**
     * @typedef CompleteAllTypeItem
     * @property id {string} The unique id to reference this CompleteAllTypeItem
     * @property renderer {object}
     * @property renderer.api {RendererApi} The renderer API object for this option
     * @property renderer.settings {RendererSettings} The renderer Settings object for this option
     * @property renderer.elem {DomElement} The Element that represents this option's renderer
     */
    /********************************************************************************/
    /*** END Type Definitions                                                     ***/
    /*** START Private API                                                        ***/
    /********************************************************************************/

    function _getUniquePropName() {
        var groupList = self.getValue();

        while (_.has(groupList, "Untitled-" + uniquePropNameIndex)) {
            uniquePropNameIndex++;
        }

        return "Untitled-" + uniquePropNameIndex;
    }

    this.getMultiEditActive = function () {
        return this._multiEditActive;
    };
    this.setMultiEditActive = function (flag) {
        if (!this._readOnlyField) {
            this.setReadOnly(!flag);
            let oldValue = this._multiEditActive;
            this._multiEditActive = flag;
            if (oldValue !== this._multiEditActive) {
                this.emit("MultiEditActive", {
                    oldValue: oldValue,
                    newValue: this._multiEditActive,
                });
            }
        }
    };

    /**
     * Fire the Value Changed Event
     * @param silent {boolean} If true will not emit the ValueChanged event.
     * @private
     */
    function _fireValueChanged(silent) {
        //Get the new Value
        var newVal = self.getValue();
        if (!silent) {
            self.emit("ValueChanged", {
                name: formCtrlDef.name,
                containingElem: containingElem,
                controlAdapter: self,
                formControlDefinition: formCtrlDef,
                oldValue: _oldValue,
                newValue: newVal,
            });
        }
        _oldValue = newVal;
    }

    /**
     * Fire the Invalid status changed Event
     * @param silent {boolean} If true will not emit the Invalid event.
     * @private
     */
    function _fireInvalidStatusChanged(silent) {
        let newVal = self.isInvalid();
        if (!silent) {
            self.emit("Invalid", {
                name: formCtrlDef.name,
                containingElem: containingElem,
                controlAdapter: self,
                formControlDefinition: formCtrlDef,
                oldValue: _oldInvalidStatus,
                newValue: newVal,
            });
        }
        _oldValue = newVal;
    }

    /**
     * Fire the InProgress status changed event
     * @param silent{bolean}
     * @private
     */
    function _fireInProgressStatusChanged(silent) {
        let newInProgressStatus = self.isInProgress();
        if (!silent) {
            self.emit("InProgress", {
                name: formCtrlDef.name,
                containingElem: containingElem,
                controlAdapter: self,
                formControlDefinition: formCtrlDef,
                oldInProgressStatus: _oldInProgressStatus,
                newInProgressStatus: newInProgressStatus,
            });
        }
        _oldInProgressStatus = newInProgressStatus;
    }

    /**
     * Creates new InputTextControlComponent
     * @param options - used to customize the InputTextControlComponent created
     * @returns {InputTextControlComponent} - new InputTextControlComponent created
     * @private
     */
    function _createInputTextControl(options) {
        let inputTextControl = new InputTextControlComponent({
            value: options.value,
            name: options.name,
            placeholder: options.placeholder,
        });
        inputTextControl.addListener("UserValue", function () {
            _fireValueChanged();
        });
        return inputTextControl;
    }

    function _setReadOnly(itemApi, flag) {
        if (itemApi.setReadOnly) {
            itemApi.setReadOnly(flag);
        } else if (itemApi.setDisabled) {
            itemApi.setDisabled(flag);
        }
    }

    /********************************************************************************/
    /*** END Private API                                                          ***/
    /*** START Public API                                                         ***/
    /********************************************************************************/
    //The name of the control
    this.name = formCtrlDef.name;

    /**
     * @returns the data associated with this control.
     */
    this.getValue = function () {
        var val = {};

        Object.keys(_itemsRegistry).forEach(function (itemId) {
            var item = _itemsRegistry[itemId];

            if (item.renderer) {
                var propName = item.renderer.propName.api.getValue();
                if (!propName) {
                    propName = "";
                }
                val[propName] = item.renderer.api.getValue();
            }
        });
        return val;
    };

    /**
     * Set this controls current value.
     * @param value {string} The value to set this control to.
     * @returns the value associated with this control, it might not always be the same as the value passed in for
     * example adapters with a ValueScope.PARENT.
     */
    this.setValue = function (value) {
        self.tearDown();
        var csProps = _typeConfigSettings["@propertyOrder"];

        Object.keys(value).forEach(function (valKey) {
            let allTypeProp = true;
            if (
                _.isArray(formCtrlDef.excludedProps) &&
                formCtrlDef.excludedProps.indexOf(valKey) > -1
            ) {
                allTypeProp = false;
            }
            if (allTypeProp) {
                var val = value[valKey];
                if (_.isPlainObject(val)) {
                    //TODO I'd like to have this based off the valueScope but I'm getting
                    //a ton of pressure like usual so I'm putting this in place to see if it
                    //gets us far enough for now
                    if (_typeConfigSettings.hasOwnProperty(valKey)) {
                        _scope.CompleteAllType.addItem(val, valKey);
                    } else {
                        var valProps = Object.keys(val);
                        //loop through the config properties
                        var addAnItemForThisVal = _.every(csProps, function (csp) {
                            var result = false;
                            //This value is inside the csp
                            if (valProps.indexOf(csp) !== -1) {
                                result = true;
                            } else {
                                var options = [];
                                if (_typeConfigSettings[csp].fieldType === "Choice") {
                                    options =
                                        _typeConfigSettings[csp].Choice.options["@propertyOrder"];
                                } else if (_typeConfigSettings[csp].fieldType === "Complete") {
                                    //Complete.options
                                    if (_typeConfigSettings[csp].options) {
                                        options =
                                            _typeConfigSettings[csp].options["@propertyOrder"];
                                    }
                                    //Complete.allType
                                    if (_typeConfigSettings[csp].allType) {
                                        options =
                                            _typeConfigSettings[csp].allType["@propertyOrder"];
                                    }
                                }

                                valProps.forEach(function (valPropKey) {
                                    if (options.indexOf(valPropKey)) {
                                        result = true;
                                    }
                                });
                            }
                            return result;
                        });
                        if (addAnItemForThisVal) {
                            //If this val object has the exact same properties make the assumption this is for this control to render
                            //Note: I am aware that technically someone could create a hard coded object of the same format... Unsupported at this point.
                            _scope.CompleteAllType.addItem(val, valKey);
                        }
                    }
                } else {
                    _scope.CompleteAllType.addItem(val, valKey);
                }
            }
        });
        return self.getValue();
    };

    /**
     * Returns if the control data is valid or not
     * @returns {boolean}
     */
    this.isInvalid = function () {
        if (this._multiEditMode && !this.getMultiEditActive()) {
            return false;
        }
        return Object.keys(_itemsRegistry).some(function (itemId) {
            let item = _itemsRegistry[itemId];
            if (item.renderer) {
                return _.isFunction(item.renderer.api.isInvalid)
                    ? item.renderer.api.isInvalid()
                    : false;
            }
        });
    };

    this.isInProgress = function () {
        return Object.keys(_itemsRegistry).some(function (itemId) {
            let item = _itemsRegistry[itemId];
            return (
                item.renderer &&
                _.isFunction(item.renderer.api.isInProgress) &&
                item.renderer.api.isInProgress()
            );
        });
    };

    /**
     * Returns validation messages on this control
     * @returns {Array}
     */
    this.getValidationMessages = function () {
        let validationMessages = {};
        Object.keys(_itemsRegistry).forEach(function (itemId) {
            let item = _itemsRegistry[itemId];
            let propName = item.renderer.propName.api.getValue();
            propName = propName ? propName : "";
            if (_.isFunction(item.renderer.api.getValidationMessages)) {
                let currentItemValidationMessages = item.renderer.api.getValidationMessages();
                if (!_.isEmpty(currentItemValidationMessages)) {
                    validationMessages[propName] = currentItemValidationMessages;
                }
            }
        });
        return validationMessages;
    };

    /**
     * Tear down this control
     */
    this.tearDown = function () {
        Object.keys(_itemsRegistry).forEach(function (itemId) {
            _scope.CompleteAllType.closeItem(itemId);
        });
    };

    /********************************************************************************/
    /*** END Public API                                                           ***/
    /*** Start Angular/Render Work                                                ***/
    /********************************************************************************/

    /**
     * A Hook to start the angular work, due to timing issues don't try anything angularis before this hook is called.
     * @param $scope {$scope} Angular $scope
     * @parma $templateCache {$templateCache}
     */
    this.$init = function ($scope, $templateCache, $timeout, $compile) {
        _scope = $scope;
        _scope.formCtrlDef = formCtrlDef;

        //if this is defaulting to a non helpful tooltip go ahead and hide it
        if (
            formCtrlDef.configSettings.allType["@Display"] &&
            formCtrlDef.configSettings.allType["@Display"].description
        ) {
            formCtrlDef.displayInfo.tooltip =
                formCtrlDef.configSettings.allType["@Display"].description;
        } else {
            formCtrlDef.displayInfo.tooltip = "";
        }

        _typeConfigSettings = formCtrlDef.configSettings.allType;
        let displayInfo;
        if (formCtrlDef.configSettings.Display) {
            displayInfo = formCtrlDef.configSettings.Display;
        }

        //Setup Settings Object
        $scope.CompleteAllType = {
            _itemsRegistry: _itemsRegistry,

            closeItem: function (itemId) {
                var item = _itemsRegistry[itemId];
                if (item) {
                    if (item.renderer.api.tearDown) {
                        item.renderer.api.tearDown();
                    } else if (item.renderer.api.shutdown) {
                        item.renderer.api.shutdown();
                    }
                    if (item.renderer.accordionIcon) {
                        item.renderer.accordionIcon.removeEventListener(
                            "click",
                            $scope.CompleteAllType.accordionClick
                        );
                    }
                    delete _itemsRegistry[itemId];
                    item.renderer.elem.remove();
                    _fireValueChanged();
                    _fireInvalidStatusChanged();
                }
            },
            /**
             * Append a new CompleteAllType Item to the end of the array
             * @param configData {ConfigurationData} The configData to populate this item with.
             */
            addItem: function (configData, propName) {
                const generateUniqueId = () => {
                    let id;
                    let attempts = 0;
                    const maxAttempts = 10000; // Limit to prevent infinite loop

                    do {
                        id = `${performance.now()}${String(Math.floor(Math.random() * 1000000))}`;
                        attempts++;
                    } while (_itemsRegistry[id] && attempts < maxAttempts);

                    return id;
                };
                let id = generateUniqueId();
                let settings;
                let glType;
                let itemClassName;
                let inputTextControl;
                // If the all type is an object then create the
                // appropriate renderer
                if (_.isArray(_typeConfigSettings)) {
                    let display;
                    if (_.has(formCtrlDef, "configSettings.Display.array")) {
                        display = _.get(formCtrlDef, "configSettings.Display.array");
                    }
                    let arrayObject = {
                        "@Complete": {
                            value: _typeConfigSettings,
                            fieldType: "Array",
                            Display: display,
                        },
                    };
                    let psuedoConfigData = {
                        "@Complete": configData,
                    };
                    settings = {
                        configurationSettings: arrayObject,
                        configurationData: psuedoConfigData,
                        refInstances: formCtrlDef.refInstances,
                        refTypes: formCtrlDef.refTypes,
                        controlAdapterRegistry: formCtrlDef.adapterInfo.controlAdapterRegistry,
                        displayModeOptions: formCtrlDef.displayModeOptions,
                    };
                    glType = "gl-form-renderer";
                    itemClassName = "complete_all_type_item_contents";
                } else if (_.isObject(_typeConfigSettings)) {
                    settings = {
                        configurationSettings: _typeConfigSettings,
                        configurationData: configData,
                        refInstances: formCtrlDef.refInstances,
                        refTypes: formCtrlDef.refTypes,
                        controlAdapterRegistry: formCtrlDef.adapterInfo.controlAdapterRegistry,
                        displayModeOptions: formCtrlDef.displayModeOptions,
                    };
                    glType = "gl-form-renderer";
                    itemClassName = "complete_all_type_item_contents";
                } else {
                    // Assume the all type is a simple type.  We will
                    // default to a text field for now.
                    // TODO handle other scalars besides text
                    let placeholder = _.get(displayInfo, "value.placeholder", "");
                    inputTextControl = _createInputTextControl({
                        value: configData || "",
                        name: id + "_value",
                        placeholder: placeholder,
                    });
                    inputTextControl
                        .getRenderer()
                        .getRootElement()
                        .classList.add("complete_all_type_item_value");
                }
                let placeholder = _.get(displayInfo, "property.placeholder", "");
                let propNameInputTextControl = _createInputTextControl({
                    value: propName || "",
                    name: id,
                    placeholder: placeholder,
                });
                let completeAllTypeElemBody = "";
                let item = {
                    id: id,
                    renderer: {
                        propName: {
                            api: propNameInputTextControl,
                        },
                        api: {},
                        settings: {},
                    },
                };
                _itemsRegistry[item.id] = item;
                if (inputTextControl) {
                    item.renderer.api = inputTextControl;
                } else {
                    item.renderer.settings = settings;
                    itemClassName +=
                        " " +
                        _.get($scope, "jTypeContext.layout.container.cssClasses", []).join(" ");
                    completeAllTypeElemBody =
                        "<" +
                        glType +
                        " " +
                        'class="' +
                        itemClassName +
                        '" ' +
                        "data-api=\"CompleteAllType._itemsRegistry['" +
                        item.id +
                        "'].renderer.api\" " +
                        "data-settings=\"CompleteAllType._itemsRegistry['" +
                        item.id +
                        "'].renderer.settings\">" +
                        "</" +
                        glType +
                        ">";
                }

                //Render
                var completeAllTypeItemRendererElem = $(
                    "<div>" +
                        '<label class="legend"> ' +
                        '<i class="fa fa-times close_item" data-ng-click="CompleteAllType.closeItem(\'' +
                        item.id +
                        "')\"></i>" +
                        "</label>" +
                        '<div class="complete_all_type_item_contents">' +
                        completeAllTypeElemBody +
                        "</div>" +
                        "</div>"
                );
                // Create a link function by compiling the template
                var linkFn = $compile(completeAllTypeItemRendererElem);
                // Create the element with the compiled template with the same scope
                var elem = linkFn($scope);
                item.renderer.elem = elem;

                // Append the element to the DOM
                containingElem.find(".complete_all_type_items_container").first().append(elem);
                let elementLabel = elem.find("label").first();
                elementLabel.prepend(propNameInputTextControl.getRenderer().getRootElement());
                propNameInputTextControl
                    .getRenderer()
                    .getRootElement()
                    .classList.add("complete_all_label");
                if (self._accordionDisplay) {
                    let accordionIcon = document.createElement("actionable-icon-gl");
                    accordionIcon.classList.add("accordion_icon");
                    accordionIcon.dataset.dark = true;
                    accordionIcon.dataset.icon = "form.expand_collapse";
                    accordionIcon.setAttribute("data-gl-complete-item", item.id);
                    accordionIcon.addEventListener("click", $scope.CompleteAllType.accordionClick);
                    elementLabel.prepend(accordionIcon);
                    item.renderer.accordionIcon = accordionIcon;
                    if (_.get(self._accordionDisplay, "default") === "collapsed") {
                        $scope.CompleteAllType.toggleAccordion(item.id);
                    }
                }
                if (inputTextControl) {
                    elem.find(".complete_all_type_item_contents")
                        .first()
                        .append(inputTextControl.getRenderer().getRootElement());
                }

                //On initial load keep track of all the added items
                // if it's a complex object
                if (_.isObject(_typeConfigSettings) && !loadedDeferred.promise.isFulfilled()) {
                    var itemDeffered = q.defer();
                    addedItemPromises.push(itemDeffered.promise);
                    //When all the nested controls are loaded
                    item.renderer.api.once("AllControlsLoaded", function (evt) {
                        itemDeffered.resolve();
                    });
                }

                //When the option being rendered's API is available
                $timeout(function () {
                    _fireValueChanged();
                    _fireInvalidStatusChanged();
                    // If it's an object, need to track when the
                    // child option's value changes
                    if (item.renderer.api.on) {
                        item.renderer.api.on("ValueChanged", function (evt) {
                            _fireValueChanged();
                        });
                        item.renderer.api.on("Invalid", function (evt) {
                            _fireInvalidStatusChanged();
                        });
                        item.renderer.api.on("InProgress", function (/*evt*/) {
                            _fireInProgressStatusChanged();
                        });
                    }
                });
            },
            accordionClick: function (evt) {
                let itemId = evt.currentTarget.getAttribute("data-gl-complete-item");
                $scope.CompleteAllType.toggleAccordion(itemId);
            },
            toggleAccordion: function (itemId) {
                var item = _itemsRegistry[itemId];
                let accordionIcon = _.get(item.renderer, "accordionIcon");
                if (accordionIcon) {
                    let itemDiv = item.renderer.elem[0];
                    let collapsed = itemDiv.classList.contains("collapsed");
                    if (collapsed) {
                        itemDiv.classList.remove("collapsed");
                    } else {
                        itemDiv.classList.add("collapsed");
                    }
                }
            },
        };

        //Setup directive
        var template = $templateCache.get(
            "templatecache/templates/complete_all_type.template.html"
        );
        var choiceElem = $(template);
        containingElem.append(choiceElem);

        let stylesConfig = _.get(formCtrlDef, "configSettings.allType.@Display.styles", {});
        StyleUtil.renderStylesConfig(stylesConfig, containingElem[0]);

        // Apply item layout styles - these styles customize how this boolean element is placed in parent layout
        let itemLayoutCssClass = _.get($scope, "jTypeContext.layout.item.cssClass", "");
        containingElem.addClass(itemLayoutCssClass);

        //Notify the world this adapter is ready to be compiled/linked and values retrieved
        self.emit("InitializationComplete", {
            initializedValue: self.getValue(),
        });
        return loadedDeferred.promise;
    };
    this.$init.$inject = ["$scope", "$templateCache", "$timeout", "$compile"];

    /**
     * A Hook for when this control has been compiled/Linked.
     * @param $scope {$scope} The Angular Scope variable
     *
     * if $compiledAndLinked.$inject is specified those injection parameters will be used as the arguments
     */
    this.$compiledAndLinked = function ($scope, $timeout) {
        if (_.get(formCtrlDef, "configSettings.Display.readOnly")) {
            this._readOnlyField = true;
        }

        if (_.has(formCtrlDef, "configSettings.allType.@Display.addLabel")) {
            var addItemElem = containingElem
                .find(".complete_all_type_footer > .complete_all_type-add-item")
                .first();
            var newText = formCtrlDef.configSettings.allType["@Display"].addLabel;
            if (newText.charAt(newText.length - 1) !== "+") {
                newText += " +";
            }
            addItemElem.text(newText);
        }
        if (_.isPlainObject(formCtrlDef.configData) && !_.isEmpty(formCtrlDef.configData)) {
            //Update used/available based on configData
            self.setValue(formCtrlDef.configData);
            $timeout(() => {
                function finished() {
                    if (self._readOnlyField) {
                        self.setReadOnly(true);
                    }
                    if (self._multiEditMode) {
                        self.setReadOnly(true);
                    }
                    loadedDeferred.resolve();
                }

                q.all(addedItemPromises).done(finished, finished);
            });
        } else {
            if (self._readOnlyField) {
                self.setReadOnly(true);
            }
            if (self._multiEditMode) {
                self.setReadOnly(true);
            }
            loadedDeferred.resolve();
        }
    };
    this.$compiledAndLinked.$inject = ["$scope", "$timeout"];

    this.setReadOnly = function (flag) {
        let allTypeFooter = containingElem.find(".complete_all_type_footer");
        let closeItems = containingElem.find(".close_item");
        if (flag) {
            if (allTypeFooter[0]) {
                allTypeFooter[0].style.visibility = "hidden";
            }
            closeItems.each((index) => {
                closeItems[index].style.visibility = "hidden";
            });
        } else {
            if (allTypeFooter[0]) {
                allTypeFooter[0].removeAttribute("style");
            }
            closeItems.each((index) => {
                closeItems[index].removeAttribute("style");
            });
        }
        let keys = Object.keys(_itemsRegistry);
        keys.forEach((key) => {
            let item = _itemsRegistry[key];
            _setReadOnly(item.renderer.propName.api, flag);
            _setReadOnly(item.renderer.api, flag);
        });
    };

    /********************************************************************************/
    /*** END Angular/Render Work                                                  ***/
    /********************************************************************************/
};
//Make this API inherit from EventEmitter
util.inherits(module.exports, EventEmitter);

//Tell the Form renderer that this is an Angular Control.
module.exports.isAngularControl = true;
module.exports.isMultiEditSupported = true;
